import { useCallback, useMemo } from "react"

import { useModalStore, type ModalProps } from "@be-miniapp/ui/store/modal"

const useModal = () => {
  const open = useModalStore((state) => state.open)
  const close = useModalStore((state) => state.close)

  const show = useCallback(
    (data: ModalProps) => {
      open(data)
    },
    [open]
  )

  const actions = useMemo(() => ({ show, close }), [show, close])

  return actions
}

export { useModal }
